<template>

  <div class="product-trace-main">
    <el-card class="product-trace-filters">
      <el-row type="flex" justify="space-between">
        <el-col :span="18">
          <el-row type="flex" justify="start" :gutter="24">
            <!-- <el-col :span="8">
              <el-select v-model="filter.vendorAliasId" size="large" placeholder="Vendor Alias" filterable clearable>
                <el-option v-for="item in vendorList" :value="item.vendorId" :label="item.vendorNameAlias || item.vendorId" :key="item.vendorId"></el-option>
              </el-select>
            </el-col>
            <el-col :span="8">
              <el-select v-model="filter.vendorId" size="large" placeholder="Vendor" filterable clearable>
                <el-option v-for="item in vendorList" :value="item.vendorId" :label="item.vendorName" :key="item.vendorId"></el-option>
              </el-select>
            </el-col>
            <el-col :span="8">
              <el-input v-model="filter.productCode" size="large" placeholder="Product Code"></el-input>
            </el-col> -->
            <el-col :span="8">
              <el-input v-model="filter.productId" size="large" placeholder="Product ID"></el-input>
            </el-col>
          </el-row>
          <!-- <el-row type="flex" justify="start" :gutter="24" class="padding-top-16">
            <el-col :span="8">
              <el-input v-model="filter.designerId" size="large" placeholder="Designer ID"></el-input>
            </el-col>
            <el-col :span="8">
              <el-input v-model="filter.colorCode" size="large" placeholder="Color Code"></el-input>
            </el-col>
          </el-row> -->
        </el-col>
        <el-col :span="6">
          <el-row>
            <span style="margin: 0 10px;">
              <el-button @click="searchPage" type="primary" icon="search" size="large">Search</el-button>
            </span>
            <el-button @click="clearFilters" type="ghost" size="large">Reset</el-button>
          </el-row>
        </el-col>
      </el-row>
    </el-card>
    <el-card class="product-trace-data">
      <el-table :data="productTableData" :loading="loading">
        <el-table-column prop="vendorName" label="Vendor" min-width="60"></el-table-column>
        <el-table-column prop="productId" label="Product ID" min-width="60"> </el-table-column>
        <el-table-column prop="productCode" label="Boutique ID" min-width="60"> </el-table-column>
        <el-table-column prop="skuId" label="SKU ID" min-width="60"> </el-table-column>
        <el-table-column prop="skuCode" label="SKU Code" min-width="60"> </el-table-column>
        <el-table-column prop="designerId" label="Designer ID" min-width="60"> </el-table-column>
        <el-table-column prop="colorCode" label="Color Code" min-width="60"> </el-table-column>
        <el-table-column prop="seasonCode" label="season" min-width="60"> </el-table-column>
        <el-table-column prop="brandName" label="Brand" min-width="60"> </el-table-column>
        <el-table-column prop="categoryPathName" label="Cagegory" min-width="60"> </el-table-column>
        <el-table-column prop="size" label="Size" min-width="60"> </el-table-column>
        <el-table-column prop="" label="Action" width="240">
          <template slot-scope="scope">
            <!-- <el-button type="primary" size="small" @click="toStockTraceView(scope.row.skuId)">Stock Trace</el-button> -->
            <el-button type="primary" size="mini" @click="goProductDetail(scope.row, 'productTrace')">商品推送历史</el-button>
            <el-button type="primary" size="mini" @click="goProductDetail(scope.row, 'syncRecord')">商品同步历史</el-button>
            <el-button class="mt10" type="primary" size="mini" @click="toNewStockTraceView(scope.row.skuId)">库存变更历史</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination class="pagePos" background @size-change="pageSizeChange" @current-change="pageChange" :current-page="currentPage" :page-sizes="[15, 25, 30, 50]" :page-size="pageSize" layout="total, prev, pager, next,sizes, jumper" :total="totalCount"></el-pagination>
    </el-card>

  </div>

</template>
<script>
import util from "@/utils/util";
import * as TraceService from "@/api/trace";
export default {
  data() {
    return {
      filter: {
        vendorAliasId: null,
        vendorId: '',
        productCode: "",
        productId: "",
        colorCode: "",
        designerId: "",
        // vendorId:0
      },
      vendorList: [],

      loading: false,
      totalCount: 0,
      pageSizeOpts: [25, 50, 100, 200],
      pageSize: 25,
      currentPage: 1,
      productTableData: []
    }
  },
  methods: {
    toStockTraceView(skuId) {
      this.$router.push({
        name: "stockTrace",
        params: { skuId: skuId }
      });
    },
    toNewStockTraceView(skuId) {
      window.open('/#/productTrace/product/newStockTrace/' + skuId)
    },
    searchPage() {
      console.log("searchPage");
      this.refreshTable();

    },
    pageChange(page) {
      this.currentPage = page;
      this.refreshTable();
    },

    pageSizeChange(pageSize) {
      this.pageSize = pageSize;
      this.refreshTable();
    },
    init() {
      this.getVendorList();
      // this.searchPage()
    },
    getVendorList() {
      TraceService.queryVendor(true).then(res => {
        if (res.data && res.data.data) {
          this.vendorList = res.data.data || [];
        }
      })
    },
    clearFilters() {
      this.filter.vendorAliasId = null;
      this.filter.vendorId = 0;
      this.filter.productCode = "";
      this.filter.productId = "";
      this.filter.colorCode = "";
      this.filter.designerId = "";
      this.currentPage = 1;

      // vendorId:0
    },
    refreshTable() {
      let queryParam = {
        pageSize: this.pageSize,
        pageNum: this.currentPage
      };
      if(this.filter.productId === ''){
        // console.error(this.filter.productId,'iii') ;
        this.$message.warning('请输入Product ID')
        return false;
      }
      if (this.filter.vendorAliasId != 0 && this.filter.vendorAliasId != undefined) {
        queryParam.vendorId = this.filter.vendorAliasId;
      } else if (this.filter.vendorId != 0 && this.filter.vendorId != undefined) {
        queryParam.vendorId = this.filter.vendorId;
      }

      if (this.filter.productCode != "" && this.filter.productCode != undefined) {
        queryParam.productCode = this.filter.productCode;
      }

      if (this.filter.productId != "" && this.filter.productId != undefined) {
        queryParam.productId = this.filter.productId;
      }

      if (this.filter.colorCode != "" && this.filter.colorCode != undefined) {
        queryParam.colorCode = this.filter.colorCode;
      }

      if (this.filter.designerId != "" && this.filter.designerId != undefined) {
        queryParam.designerId = this.filter.designerId;
      }


      this.loading = true;
      TraceService.searchProduct(queryParam).then(res => {
        if (res.data.status === 1) {
          this.productTableData = res.data.data;
          // console.log(JSON.stringify(this.productTableData));
          // this.totalCount = res.data.data;
        } else {
          this.$message(res.data.data);
        }
      })
      this.loading = false;
      TraceService.searchProductCount(queryParam).then(res => {
        if (res.data.status === 1) {
          console.log(JSON.stringify(res.data));
          this.totalCount = res.data.data;
        } else {
          this.$message(res.data.data);
        }
      })
    },
    goProductDetail(row, tab) {
      window.open('/#/productManagement/detail/'+row.productId+'/0' + '?tab=' + tab);
    },
  },
  mounted() {
    this.init();
  }
}
</script>
<style>
.mt10 {
  margin-top: 10px;
}
</style>
<style lang="less">
.pagePos {
  margin-top: 20px;
  transform: translateX(60%);
}
@import "./product-trace.less";
@import "../../styles/common.less";
</style>

